module.exports = __webpack_public_path__ + "img/Icon-ellipsis-v.eb3a1342.svg";